var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "page-editor-ui": "static-1.36591",
      "apollo-dlb": "static-3.73",
      "client-types": "static-1.400",
      "codemirror-dlb": "static-1.56944",
      "collaboration-sidebar": "static-1.56141",
      "ContentComponents": "static-2.69305",
      "ContentData": "static-1.66424",
      "ContentEditorUI": "static-2.75385",
      "ContentUtils": "static-1.66349",
      "customer-agent-discovery-components-lib": "static-1.1426",
      "data-fetching-client": "static-1.9015",
      "editor-components": "static-1.12383",
      "emoji-mart": "static-3.4",
      "FileManagerLib": "static-1.37419",
      "foundations-assets": "static-1.4208",
      "foundations-components": "static-1.6856",
      "head-dlb": "static-1.4360",
      "hs-test-utils": "static-1.7343",
      "hub-http": "static-1.5499",
      "hub-http-shared-msw-handlers": "static-1.8458",
      "hubspot-dlb": "static-2.1707",
      "HubStyleTokens": "static-2.10864",
      "I18n": "static-7.1452",
      "InpageEditorUI": "static-1.83825",
      "jasmine-immutable": "static-1.2314",
      "jasmine-runner": "static-1.5770",
      "layout-dnd-utils": "static-1.10328",
      "personalization-lib": "static-1.5494",
      "quartz": "static-1.6162",
      "react-dlb": "static-1.62",
      "react-dnd": "static-4.51",
      "react-dnd-html5-backend": "static-4.5",
      "react-redux": "static-7.16",
      "react-router-dom": "static-5.26",
      "react-utils": "static-2.4737",
      "redux-thunk": "static-2.43",
      "settings-ui-lib": "static-1.11880",
      "sinon": "static-1.9",
      "tinymce": "static-6.5",
      "ui-addon-draggable": "static-1.4373",
      "ui-components-test-utils": "static-1.5002",
      "ui-images": "static-2.966",
      "ui-memberships-settings-lib": "static-1.32144",
      "video-components-external": "static-1.9425",
      "webpack-env": "static-1.54",
      "ai-components-ui-library": "static-1.7306",
      "amplitude-session-replay-browser": "static-1.45",
      "apollo-stack-hubspot": "static-3.69",
      "asset-actions-lib": "static-1.44301",
      "atom": "static-1.4498",
      "blueimp-md5": "static-1.8",
      "campaigns-lib": "static-1.25411",
      "classnames": "static-2.10",
      "content-assistance-lib": "static-1.6981",
      "content-management-actions-lib": "static-1.25935",
      "content-management-data-lib": "static-1.4524",
      "content-management-restrictions-lib": "static-1.4297",
      "copilot-plugins": "static-1.9412",
      "copilot-toolkit": "static-1.9439",
      "cropperjs": "static-1.10",
      "cssUtils": "static-1.602",
      "cta-picker": "static-1.34882",
      "customer-data-objects": "static-1.6989",
      "customer-data-objects-ui-components": "static-1.12323",
      "customer-data-properties": "static-1.49508",
      "customer-data-property-utils": "static-1.7316",
      "customer-data-reference-ui-components": "static-1.12417",
      "customer-data-ui-utilities": "static-1.9119",
      "data-token-picker": "static-1.15323",
      "data-token-views": "static-1.15304",
      "error-messaging-js": "static-1.4622",
      "feedback-loader": "static-1.28013",
      "file-manager-components": "static-1.21779",
      "FileManagerCore": "static-1.37278",
      "FormsCommonComponents": "static-1.84153",
      "foundations-theming": "static-1.3692",
      "fuzzy": "static-1.8",
      "growth-onboarding-beacon": "static-1.4166",
      "growth-onboarding-confetti": "static-1.2427",
      "growth-onboarding-next-action-components": "static-1.777",
      "growth-payments-core": "static-1.23559",
      "history": "static-4.47",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.4873",
      "hub-http-contrib": "static-1.2450",
      "hubspot-url-utils": "static-1.3531",
      "HubStyle": "static-2.11172",
      "icons": "static-2.596",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "InboxConnectUtils": "static-4.13194",
      "integrations-lib": "static-1.14194",
      "interframe": "static-3.4113",
      "laboratory-lib": "static-3.6539",
      "layout-data-lib": "static-1.8653",
      "media-bridge-lib": "static-1.17923",
      "nav-meta": "static-1.27821",
      "object-builder-ui-client": "static-1.46655",
      "onboarding-scopes": "static-1.5868",
      "onboarding-tours": "static-1.15702",
      "onboarding-tours-client": "static-1.3916",
      "outpost": "static-1.3675",
      "page-lib": "static-1.20588",
      "PatternValidationJS": "static-1.437",
      "payment-link-components": "static-1.21903",
      "payments-post-enroll-local-storage-lib": "static-1.4422",
      "pictos": "static-7.169",
      "PortalIdParser": "static-2.306",
      "products-ui-components": "static-1.38151",
      "property-translator": "static-1.4721",
      "quick-fetch": "static-1.2772",
      "raven": "static-3.5229",
      "react": "static-7.151",
      "react-beautiful-dnd": "static-1.13",
      "react-colorpicker": "static-2.9609",
      "react-dom": "static-7.85",
      "react-flip-move": "static-1.55",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "react-rhumb": "static-1.15951",
      "react-select-plus": "static-1.65",
      "react-tinymce": "static-1.53469",
      "react-transition-group": "static-1.7",
      "react-virtualized": "static-2.82",
      "redux": "static-4.16",
      "redux-request-state": "static-1.9927",
      "reference-resolvers": "static-1.7521",
      "reference-resolvers-lite": "static-1.7399",
      "reselect": "static-2.16",
      "rich-text-lib": "static-1.18690",
      "rpc-client-utils": "static-1.4046",
      "sanitize": "static-1.3726",
      "sanitize-text": "static-1.7501",
      "seamless-immutable": "static-7.6",
      "self-service-api": "static-1.9598",
      "SharedI18nStrings": "static-1.171",
      "SharedLegalStrings": "static-1.1373",
      "simple-menus-core": "static-1.14189",
      "simple-menus-lib": "static-1.15706",
      "smart-content-lib": "static-1.41400",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.476",
      "superstore": "static-1.4069",
      "theme-previewer-lib": "static-1.51526",
      "tinymce-config": "static-2.52595",
      "tinymce-copilot": "static-1.14663",
      "tinymce-data": "static-1.38680",
      "tinymce-plugins": "static-1.55709",
      "tinymce-themes": "static-1.54565",
      "transmute": "static-2.77",
      "ui-addon-emoji-picker": "static-1.9283",
      "ui-addon-form-validation": "static-1.10373",
      "ui-addon-i18n": "static-1.10337",
      "ui-addon-iframeable": "static-1.8267",
      "ui-addon-opt": "static-4.7851",
      "ui-addon-sales-email": "static-1.4551",
      "ui-addon-upgrades": "static-9.16975",
      "ui-business-units-lib": "static-1.8273",
      "ui-gdpr-components": "static-1.9580",
      "ui-product-approvals": "static-1.26295",
      "ui-shepherd-react": "static-3.9421",
      "ui-suspension-banners-lib": "static-1.5718",
      "UIComponents": "static-3.7811",
      "underscore": "static-1.8",
      "urlinator": "static-1.3888",
      "usage-tracker": "static-1.6779",
      "usage-tracker-core": "static-1.6629",
      "usage-tracker-session-replay": "static-1.4465",
      "user-context": "static-1.4539",
      "video-embed": "static-1.33917",
      "web-interactives-components": "static-1.12764",
      "web-interactives-data": "static-1.12765",
      "wootric-nps": "static-1.6171",
      "xray-recommendation-lib": "static-1.6975",
      "codemirror": "static-5.80",
      "react-codemirror": "static-1.9956",
      "enviro": "static-4.328",
      "hs-promise-rejection-tracking": "static-1.4750",
      "raven-hubspot": "static-1.5536",
      "hoist-non-react-statics": "static-3.9",
      "metrics-js": "static-1.9058",
      "bend-plugin-trellis-migration": "static-1.2883",
      "moment": "static-3.26",
      "chatspot-client-types": "static-1.10032",
      "chatspot-core": "static-1.18906",
      "chatspot-widget-iframe": "static-1.18898",
      "collaboration-sidebar-common": "static-1.937",
      "framework-data-schema-resolvers": "static-1.6241",
      "frontend-preferences-client": "static-1.7286",
      "magpie-lib": "static-1.5002",
      "magpie-types": "static-1.4462",
      "quartz-core": "static-1.5381",
      "simple-logging-lib": "static-1.2344",
      "ts-schema": "static-1.3526",
      "advanced-menus-core": "static-1.14190",
      "advanced-menus-lib": "static-1.11256",
      "avatar-components": "static-1.1828",
      "cms-field-types": "static-1.4105",
      "content-embed-lib": "static-1.6688",
      "ExportDialog": "static-6.9817",
      "forms-utils-lib": "static-1.11388",
      "integrations-error-boundary-lib": "static-1.11609",
      "payments-embed-points-lib": "static-1.11676",
      "products-iframe-lib": "static-1.6248",
      "react-dnd-compat": "static-1.4022",
      "usage-tracker-container": "static-1.6769",
      "video-data-lib": "static-1.33083",
      "videoconference-integration-components": "static-1.5893",
      "graphql": "static-1.67",
      "backbone": "static-1.6",
      "editor-iframe-lib": "static-1.7675",
      "FireAlarmUi": "static-1.4022",
      "hubspot-apollo-client": "static-1.4173",
      "layout-dnd-components": "static-1.11353",
      "marketing-email-service-types": "static-1.1620",
      "smart-content-core": "static-1.40747",
      "social-composer-lib": "static-1.56583",
      "structured-content-lib": "static-1.23593",
      "timezone-utils": "static-2.4548",
      "ui-active-theme-content-creator-lib": "static-1.36381",
      "ui-addon-video-player": "static-1.8103",
      "ui-asset-management-lib": "static-1.10064",
      "ui-brand-identity-lib": "static-1.12230",
      "ui-tool-access": "static-1.9427",
      "content-icons-ui": "static-1.2015",
      "foundations-theming-specialty": "static-1.1408",
      "directed-graph": "static-1.284",
      "event-emitter": "static-1.348",
      "fast-json-stable-stringify": "static-1.4",
      "react-aria": "static-1.44",
      "audio-components": "static-1.5121",
      "FileManagerImages": "static-1.34930",
      "video-components": "static-1.11428",
      "hs-story-utils": "static-1.8714",
      "bend-plugin-foundations-components": "static-1.3125",
      "floating-ui": "static-1.41",
      "framer-motion": "static-1.53",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.334",
      "HeadJS": "static-2.623",
      "hs-test-utils-bend-plugin": "static-1.2454",
      "msw": "static-1.39",
      "testing-library": "static-1.135",
      "i18n-data": "static-1.208",
      "moment-timezone": "static-5.68",
      "jquery": "static-3.6",
      "NamespacedHubStyle": "static-2.8606",
      "react-dnd-ipeui-backend": "static-1.1396",
      "ui-coaching-tips": "static-1.26726",
      "jasmine": "static-4.3660",
      "marketplace-embed": "static-1.20338",
      "ui-addon-react-router-dom": "static-1.8952",
      "quartz-core-utils": "static-1.3029",
      "flux-actions": "static-1.287",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9817",
      "rxjs": "static-5.10",
      "foundations-components-test-utils": "static-1.4340",
      "apollo-link-hub-http": "static-2.4078",
      "content-media-composition-data-lib": "static-1.9627",
      "content-media-compositions": "static-2.13634",
      "idb-keyval": "static-1.29",
      "immerable": "static-1.3462",
      "autolinker": "static-3.11",
      "foundations-theming-base": "static-1.2677",
      "sassPrefix": "static-1.142",
      "marketing-platform-lib": "static-1.6115",
      "attribution-lib": "static-1.40742",
      "crm-pipelines-api-client-types": "static-1.3499",
      "crm-message-bus": "static-1.41232",
      "reporting-ui-components": "static-2.62221",
      "ai-rendering-library": "static-1.8106",
      "inbound-db-properties-service-client": "static-1.3354",
      "calling-cross-tab-library": "static-1.18636",
      "calling-global-api": "static-1.62305",
      "calling-integration-cross-tab": "static-1.21396",
      "calling-internal-common": "static-1.30634",
      "calling-lifecycle-internal": "static-1.63687",
      "calling-lifecycle-messages": "static-1.55981",
      "conditional-properties-service-client": "static-1.3314",
      "crm-links": "static-1.5538",
      "external-options-client-types": "static-1.3522",
      "google-libphonenumber": "static-1.21",
      "inbound-db-meta-service-client": "static-1.3133",
      "inbounddb-objects-service-types": "static-1.3625",
      "pipeline-validation-client-types": "static-1.3319",
      "smart-property-lib": "static-1.4429",
      "tiered-pricing": "static-1.242",
      "react-immutable-render-mixin": "static-1.9",
      "redux-toolkit": "static-1.7",
      "salesImages": "static-1.511",
      "forms-ai-lib": "static-1.3091",
      "bend-plugin-foundations-theming": "static-1.2175",
      "embedded-academy-lib": "static-1.12398",
      "growth-onboarding-feedback-components": "static-1.5849",
      "commerce-analytics-service-client": "static-1.3009",
      "integrations-tracking-lib": "static-1.4994",
      "native-integrations-shared-strings": "static-1.7155",
      "ui-universal-auth": "static-1.8208",
      "getting-started-shared-tasks": "static-1.16715",
      "growth-data-modal": "static-1.4658",
      "growth-onboarding-next-action-utils": "static-1.749",
      "navigation-components": "static-1.16184",
      "ui-shepherd-tracker": "static-1.6802",
      "commerce-tours-lib": "static-1.5066",
      "growth-onboarding-reliability": "static-1.4475",
      "sales-checkout-service-client": "static-1.3021",
      "commerce-products-lib": "static-1.7631",
      "commerce-shared-components-lib": "static-1.16866",
      "commerce-subscription-lib": "static-1.35323",
      "crm_components": "static-3.89969",
      "crm_data": "static-4.89969",
      "customer-data-filters-ui": "static-1.37436",
      "customer-data-tracking": "static-1.6196",
      "dispatcher": "static-1.122",
      "framework-data-table": "static-2.10516",
      "property-description-translator": "static-1.3173",
      "csstype": "static-1.50",
      "batch-promise": "static-1.947",
      "growth-monetization-service-types": "static-1.4006",
      "merchandise-lib": "static-1.233",
      "commerce-tools-ui-lib": "static-1.8898",
      "redux-mock-store": "static-1.8",
      "redux-undo": "static-1.10",
      "hubspotter-http": "static-1.3998",
      "navigation-messaging": "static-1.5511",
      "feature-store-service-types": "static-1.3999",
      "upgrade-management-service-types": "static-1.3990",
      "getting-started-shared-tasks-store": "static-1.15833",
      "seo-tools-lib": "static-1.5775",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "markdown-it": "static-1.6",
      "zustand": "static-1.51",
      "framework-builder-read-service-client": "static-1.3474",
      "framework-data-schema-quick-fetch": "static-1.6146",
      "persist-promise": "static-1.3105",
      "hub-http-janus": "static-1.699",
      "reactive-lib": "static-1.93",
      "general-store": "static-6.20",
      "hubspotter-http-shared-msw-handlers": "static-1.8456",
      "mobile-manifest-mixins": "static-1.395",
      "platform-navigation-bootstrap": "static-1.11855",
      "payments-enrollment-embed-lib": "static-1.20637",
      "social-insights-client-types": "static-1.20289",
      "marketplace-ui-client-types": "static-1.15212",
      "marketplace-ui-common": "static-1.17805",
      "marketplace-ui-details": "static-1.7702",
      "property-management-iframe": "static-1.10904",
      "trellis-ecosystem": "static-1.5959",
      "hls.js": "static-1.24",
      "js-cookie": "static-1.18",
      "FormUrlGenerator": "static-2.4054",
      "highcharts": "static-8.89",
      "report-customization-components": "static-1.11525",
      "reporting-action-components": "static-1.39589",
      "reporting-data": "static-1.64947",
      "reporting-enablement": "static-1.20785",
      "reporting-snowflake": "static-1.53567",
      "reporting-visualizations": "static-1.57024",
      "reporting-plugins": "static-1.9288",
      "reporting-reports": "static-1.64627",
      "highlight.js": "static-1.45",
      "ui-addon-teams": "static-1.20700",
      "shared-worker-versioning": "static-1.10419",
      "calling-error-reporting": "static-1.30640",
      "worker-connection-library": "static-1.15864",
      "calling-usage-tracker": "static-1.5844",
      "calling-orchestration-shared-library": "static-1.33537",
      "conversations-skeleton-state": "static-1.6712",
      "location-customization-utils-lib": "static-1.7302",
      "breeze-intelligence-kit": "static-1.4694",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8541",
      "fsm": "static-1.3045",
      "policy-lib": "static-1.6111",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.8604",
      "final-form": "static-1.53",
      "academy-common-lib": "static-1.11858",
      "universal-page-editor-lib": "static-1.2395",
      "products-ui-components-shared-msw-handlers": "static-1.8840",
      "commerce-billing-lib": "static-1.17402",
      "crm_universal": "static-1.21156",
      "customer-data-content": "static-1.26083",
      "crm_schema": "static-3.90008",
      "customer-data-email": "static-1.16930",
      "customer-data-filters-ui-msw-helpers": "static-1.19870",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.361",
      "customer-data-associations": "static-1.6577",
      "customer-data-rte": "static-1.31528",
      "cv-backend-services": "static-1.1336",
      "growth-onboarding-empty-states": "static-1.4859",
      "hubspot-prosemirror": "static-1.16492",
      "prosemirror": "static-1.13",
      "qrcode-generator": "static-1.52",
      "quotes-client-types": "static-1.35862",
      "trials-service-types": "static-1.3407",
      "platform-infra-nav-components": "static-1.7108",
      "marketplace-ui-apps-core": "static-1.16339",
      "stripe-embedded-components": "static-1.6489",
      "ai-settings-ui-library": "static-1.6724",
      "immutable-less": "static-1.3908",
      "react-window": "static-1.13",
      "ai-studio-lib": "static-1.9752",
      "developer-experience-shared-components": "static-1.9699",
      "marketplace-ui-reviews": "static-1.17762",
      "marketplace-ui-tracking": "static-1.11977",
      "ui-addon-integrations-directory-panel": "static-2.7400",
      "usage-based-billing-components-lib": "static-1.7010",
      "property-management-common": "static-1.3191",
      "storybook-react": "static-1.16",
      "trellis-story-utils": "static-1.3896",
      "dashboard-lib": "static-1.79135",
      "share-with-third-party-component-lib": "static-1.8053",
      "reporting-client-types": "static-1.2251",
      "data-quality-ui-library": "static-1.11289",
      "html-to-image": "static-1.38",
      "reporting-datasets-permissions-lib": "static-1.11720",
      "crm-object-map": "static-1.4292",
      "campaign-roi-lib": "static-1.7065",
      "calling-orchestration-schema": "static-1.33762",
      "crm-record-cards-service-types": "static-1.3091",
      "academy-service-client": "static-1.2993",
      "multi-currency-client-types": "static-1.3135",
      "sales-views-client-types": "static-1.3607",
      "utility-belt": "static-1.1847",
      "SalesContentIndexUI": "static-3.8156",
      "sequences-lib": "static-1.7101",
      "draft-content-plugins": "static-1.26877",
      "draft-convert": "static-2.31",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-plugins": "static-2.20523",
      "knowledge-content-types": "static-1.8036",
      "ui-extensibility-client-types": "static-1.3395",
      "stripe-connect-js": "static-1.43",
      "apps-service-types": "static-1.3341",
      "oauth-service-types": "static-1.3593",
      "subscription-experience-data-types": "static-1.13846",
      "crm-component-utils": "static-1.37412",
      "redux-actions": "static-3.7",
      "crm-fe-perf": "static-1.22315",
      "crm-index-visualization-object-layout": "static-1.3935",
      "crm-object-search-query-utilities": "static-1.8245",
      "sales-templates-service-types-lib": "static-1.3584",
      "sequences-client-types-lib": "static-1.6958",
      "card-properties-lib": "static-1.42378",
      "crm-actions": "static-1.5550",
      "crm-cards-data": "static-1.340",
      "crm-cards-sdk": "static-1.41678",
      "customer-data-properties-shared-msw-handlers": "static-1.7785",
      "customer-data-sidebar": "static-2.44304",
      "enrichment-properties-lib": "static-1.13547",
      "card-payment-highlight-lib": "static-1.35438",
      "card-subscription-highlight-lib": "static-1.37746",
      "commerce-contract-lib": "static-1.9922",
      "invoices-highlight-card-lib": "static-1.52755",
      "orders-highlight-card-lib": "static-1.19967",
      "products-highlight-card-lib": "static-1.15916",
      "project-storage": "static-1.4041",
      "quotes-highlight-card-lib": "static-1.69777",
      "crm-source-interpretation-lib": "static-1.4638",
      "quotes-ui-lib": "static-1.78493",
      "accounting-integrations-ui-components": "static-1.5995",
      "invoices-ui-lib": "static-1.52771",
      "commerce-products-api": "static-1.1287",
      "SafeStorage": "static-1.3730",
      "invoices-iframe-lib": "static-1.54829",
      "quotes-modal-lib": "static-1.100450",
      "totals-ui-components": "static-1.21915",
      "commerce-totals-service-types": "static-1.3262"
    },
    "depPathPrefixes": {
      "page-editor-ui": "/page-editor-ui/static-1.36591",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "client-types": "/client-types/static-1.400",
      "codemirror-dlb": "/codemirror-dlb/static-1.56944",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56141",
      "ContentComponents": "/ContentComponents/static-2.69305",
      "ContentData": "/ContentData/static-1.66424",
      "ContentEditorUI": "/ContentEditorUI/static-2.75385",
      "ContentUtils": "/ContentUtils/static-1.66349",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.1426",
      "data-fetching-client": "/data-fetching-client/static-1.9015",
      "editor-components": "/editor-components/static-1.12383",
      "emoji-mart": "/emoji-mart/static-3.4",
      "FileManagerLib": "/FileManagerLib/static-1.37419",
      "foundations-assets": "/foundations-assets/static-1.4208",
      "foundations-components": "/foundations-components/static-1.6856",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-test-utils": "/hs-test-utils/static-1.7343",
      "hub-http": "/hub-http/static-1.5499",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8458",
      "hubspot-dlb": "/hubspot-dlb/static-2.1707",
      "HubStyleTokens": "/HubStyleTokens/static-2.10864",
      "I18n": "/I18n/static-7.1452",
      "InpageEditorUI": "/InpageEditorUI/static-1.83825",
      "jasmine-immutable": "/jasmine-immutable/static-1.2314",
      "jasmine-runner": "/jasmine-runner/static-1.5770",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10328",
      "personalization-lib": "/personalization-lib/static-1.5494",
      "quartz": "/quartz/static-1.6162",
      "react-dlb": "/react-dlb/static-1.62",
      "react-dnd": "/react-dnd/static-4.51",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
      "react-redux": "/react-redux/static-7.16",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-utils": "/react-utils/static-2.4737",
      "redux-thunk": "/redux-thunk/static-2.43",
      "settings-ui-lib": "/settings-ui-lib/static-1.11880",
      "sinon": "/sinon/static-1.9",
      "tinymce": "/tinymce/static-6.5",
      "ui-addon-draggable": "/ui-addon-draggable/static-1.4373",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5002",
      "ui-images": "/ui-images/static-2.966",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32144",
      "video-components-external": "/video-components-external/static-1.9425",
      "webpack-env": "/webpack-env/static-1.54",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7306",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.45",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "asset-actions-lib": "/asset-actions-lib/static-1.44301",
      "atom": "/atom/static-1.4498",
      "blueimp-md5": "/blueimp-md5/static-1.8",
      "campaigns-lib": "/campaigns-lib/static-1.25411",
      "classnames": "/classnames/static-2.10",
      "content-assistance-lib": "/content-assistance-lib/static-1.6981",
      "content-management-actions-lib": "/content-management-actions-lib/static-1.25935",
      "content-management-data-lib": "/content-management-data-lib/static-1.4524",
      "content-management-restrictions-lib": "/content-management-restrictions-lib/static-1.4297",
      "copilot-plugins": "/copilot-plugins/static-1.9412",
      "copilot-toolkit": "/copilot-toolkit/static-1.9439",
      "cropperjs": "/cropperjs/static-1.10",
      "cssUtils": "/cssUtils/static-1.602",
      "cta-picker": "/cta-picker/static-1.34882",
      "customer-data-objects": "/customer-data-objects/static-1.6989",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12323",
      "customer-data-properties": "/customer-data-properties/static-1.49508",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7316",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12417",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9119",
      "data-token-picker": "/data-token-picker/static-1.15323",
      "data-token-views": "/data-token-views/static-1.15304",
      "error-messaging-js": "/error-messaging-js/static-1.4622",
      "feedback-loader": "/feedback-loader/static-1.28013",
      "file-manager-components": "/file-manager-components/static-1.21779",
      "FileManagerCore": "/FileManagerCore/static-1.37278",
      "FormsCommonComponents": "/FormsCommonComponents/static-1.84153",
      "foundations-theming": "/foundations-theming/static-1.3692",
      "fuzzy": "/fuzzy/static-1.8",
      "growth-onboarding-beacon": "/growth-onboarding-beacon/static-1.4166",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2427",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.777",
      "growth-payments-core": "/growth-payments-core/static-1.23559",
      "history": "/history/static-4.47",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.4873",
      "hub-http-contrib": "/hub-http-contrib/static-1.2450",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
      "HubStyle": "/HubStyle/static-2.11172",
      "icons": "/icons/static-2.596",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13194",
      "integrations-lib": "/integrations-lib/static-1.14194",
      "interframe": "/interframe/static-3.4113",
      "laboratory-lib": "/laboratory-lib/static-3.6539",
      "layout-data-lib": "/layout-data-lib/static-1.8653",
      "media-bridge-lib": "/media-bridge-lib/static-1.17923",
      "nav-meta": "/nav-meta/static-1.27821",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.46655",
      "onboarding-scopes": "/onboarding-scopes/static-1.5868",
      "onboarding-tours": "/onboarding-tours/static-1.15702",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.3916",
      "outpost": "/outpost/static-1.3675",
      "page-lib": "/page-lib/static-1.20588",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "payment-link-components": "/payment-link-components/static-1.21903",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4422",
      "pictos": "/pictos/static-7.169",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "products-ui-components": "/products-ui-components/static-1.38151",
      "property-translator": "/property-translator/static-1.4721",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "raven": "/raven/static-3.5229",
      "react": "/react/static-7.151",
      "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
      "react-colorpicker": "/react-colorpicker/static-2.9609",
      "react-dom": "/react-dom/static-7.85",
      "react-flip-move": "/react-flip-move/static-1.55",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-rhumb": "/react-rhumb/static-1.15951",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-tinymce": "/react-tinymce/static-1.53469",
      "react-transition-group": "/react-transition-group/static-1.7",
      "react-virtualized": "/react-virtualized/static-2.82",
      "redux": "/redux/static-4.16",
      "redux-request-state": "/redux-request-state/static-1.9927",
      "reference-resolvers": "/reference-resolvers/static-1.7521",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7399",
      "reselect": "/reselect/static-2.16",
      "rich-text-lib": "/rich-text-lib/static-1.18690",
      "rpc-client-utils": "/rpc-client-utils/static-1.4046",
      "sanitize": "/sanitize/static-1.3726",
      "sanitize-text": "/sanitize-text/static-1.7501",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "self-service-api": "/self-service-api/static-1.9598",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.171",
      "SharedLegalStrings": "/SharedLegalStrings/static-1.1373",
      "simple-menus-core": "/simple-menus-core/static-1.14189",
      "simple-menus-lib": "/simple-menus-lib/static-1.15706",
      "smart-content-lib": "/smart-content-lib/static-1.41400",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.476",
      "superstore": "/superstore/static-1.4069",
      "theme-previewer-lib": "/theme-previewer-lib/static-1.51526",
      "tinymce-config": "/tinymce-config/static-2.52595",
      "tinymce-copilot": "/tinymce-copilot/static-1.14663",
      "tinymce-data": "/tinymce-data/static-1.38680",
      "tinymce-plugins": "/tinymce-plugins/static-1.55709",
      "tinymce-themes": "/tinymce-themes/static-1.54565",
      "transmute": "/transmute/static-2.77",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9283",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10373",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10337",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8267",
      "ui-addon-opt": "/ui-addon-opt/static-4.7851",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4551",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16975",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8273",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9580",
      "ui-product-approvals": "/ui-product-approvals/static-1.26295",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9421",
      "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.5718",
      "UIComponents": "/UIComponents/static-3.7811",
      "underscore": "/underscore/static-1.8",
      "urlinator": "/urlinator/static-1.3888",
      "usage-tracker": "/usage-tracker/static-1.6779",
      "usage-tracker-core": "/usage-tracker-core/static-1.6629",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4465",
      "user-context": "/user-context/static-1.4539",
      "video-embed": "/video-embed/static-1.33917",
      "web-interactives-components": "/web-interactives-components/static-1.12764",
      "web-interactives-data": "/web-interactives-data/static-1.12765",
      "wootric-nps": "/wootric-nps/static-1.6171",
      "xray-recommendation-lib": "/xray-recommendation-lib/static-1.6975",
      "codemirror": "/codemirror/static-5.80",
      "react-codemirror": "/react-codemirror/static-1.9956",
      "enviro": "/enviro/static-4.328",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "metrics-js": "/metrics-js/static-1.9058",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2883",
      "moment": "/moment/static-3.26",
      "chatspot-client-types": "/chatspot-client-types/static-1.10032",
      "chatspot-core": "/chatspot-core/static-1.18906",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.18898",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.937",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6241",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7286",
      "magpie-lib": "/magpie-lib/static-1.5002",
      "magpie-types": "/magpie-types/static-1.4462",
      "quartz-core": "/quartz-core/static-1.5381",
      "simple-logging-lib": "/simple-logging-lib/static-1.2344",
      "ts-schema": "/ts-schema/static-1.3526",
      "advanced-menus-core": "/advanced-menus-core/static-1.14190",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11256",
      "avatar-components": "/avatar-components/static-1.1828",
      "cms-field-types": "/cms-field-types/static-1.4105",
      "content-embed-lib": "/content-embed-lib/static-1.6688",
      "ExportDialog": "/ExportDialog/static-6.9817",
      "forms-utils-lib": "/forms-utils-lib/static-1.11388",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.11609",
      "payments-embed-points-lib": "/payments-embed-points-lib/static-1.11676",
      "products-iframe-lib": "/products-iframe-lib/static-1.6248",
      "react-dnd-compat": "/react-dnd-compat/static-1.4022",
      "usage-tracker-container": "/usage-tracker-container/static-1.6769",
      "video-data-lib": "/video-data-lib/static-1.33083",
      "videoconference-integration-components": "/videoconference-integration-components/static-1.5893",
      "graphql": "/graphql/static-1.67",
      "backbone": "/backbone/static-1.6",
      "editor-iframe-lib": "/editor-iframe-lib/static-1.7675",
      "FireAlarmUi": "/FireAlarmUi/static-1.4022",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4173",
      "layout-dnd-components": "/layout-dnd-components/static-1.11353",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1620",
      "smart-content-core": "/smart-content-core/static-1.40747",
      "social-composer-lib": "/social-composer-lib/static-1.56583",
      "structured-content-lib": "/structured-content-lib/static-1.23593",
      "timezone-utils": "/timezone-utils/static-2.4548",
      "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.36381",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8103",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10064",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12230",
      "ui-tool-access": "/ui-tool-access/static-1.9427",
      "content-icons-ui": "/content-icons-ui/static-1.2015",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1408",
      "directed-graph": "/directed-graph/static-1.284",
      "event-emitter": "/event-emitter/static-1.348",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "react-aria": "/react-aria/static-1.44",
      "audio-components": "/audio-components/static-1.5121",
      "FileManagerImages": "/FileManagerImages/static-1.34930",
      "video-components": "/video-components/static-1.11428",
      "hs-story-utils": "/hs-story-utils/static-1.8714",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3125",
      "floating-ui": "/floating-ui/static-1.41",
      "framer-motion": "/framer-motion/static-1.53",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.334",
      "HeadJS": "/HeadJS/static-2.623",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2454",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.135",
      "i18n-data": "/i18n-data/static-1.208",
      "moment-timezone": "/moment-timezone/static-5.68",
      "jquery": "/jquery/static-3.6",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8606",
      "react-dnd-ipeui-backend": "/react-dnd-ipeui-backend/static-1.1396",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.26726",
      "jasmine": "/jasmine/static-4.3660",
      "marketplace-embed": "/marketplace-embed/static-1.20338",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8952",
      "quartz-core-utils": "/quartz-core-utils/static-1.3029",
      "flux-actions": "/flux-actions/static-1.287",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9817",
      "rxjs": "/rxjs/static-5.10",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4340",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4078",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.9627",
      "content-media-compositions": "/content-media-compositions/static-2.13634",
      "idb-keyval": "/idb-keyval/static-1.29",
      "immerable": "/immerable/static-1.3462",
      "autolinker": "/autolinker/static-3.11",
      "foundations-theming-base": "/foundations-theming-base/static-1.2677",
      "sassPrefix": "/sassPrefix/static-1.142",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6115",
      "attribution-lib": "/attribution-lib/static-1.40742",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3499",
      "crm-message-bus": "/crm-message-bus/static-1.41232",
      "reporting-ui-components": "/reporting-ui-components/static-2.62221",
      "ai-rendering-library": "/ai-rendering-library/static-1.8106",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3354",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18636",
      "calling-global-api": "/calling-global-api/static-1.62305",
      "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.21396",
      "calling-internal-common": "/calling-internal-common/static-1.30634",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.63687",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.55981",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3314",
      "crm-links": "/crm-links/static-1.5538",
      "external-options-client-types": "/external-options-client-types/static-1.3522",
      "google-libphonenumber": "/google-libphonenumber/static-1.21",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3133",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3625",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3319",
      "smart-property-lib": "/smart-property-lib/static-1.4429",
      "tiered-pricing": "/tiered-pricing/static-1.242",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "salesImages": "/salesImages/static-1.511",
      "forms-ai-lib": "/forms-ai-lib/static-1.3091",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2175",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.12398",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5849",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3009",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4994",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7155",
      "ui-universal-auth": "/ui-universal-auth/static-1.8208",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.16715",
      "growth-data-modal": "/growth-data-modal/static-1.4658",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.749",
      "navigation-components": "/navigation-components/static-1.16184",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6802",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5066",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4475",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3021",
      "commerce-products-lib": "/commerce-products-lib/static-1.7631",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.16866",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35323",
      "crm_components": "/crm_components/static-3.89969",
      "crm_data": "/crm_data/static-4.89969",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.37436",
      "customer-data-tracking": "/customer-data-tracking/static-1.6196",
      "dispatcher": "/dispatcher/static-1.122",
      "framework-data-table": "/framework-data-table/static-2.10516",
      "property-description-translator": "/property-description-translator/static-1.3173",
      "csstype": "/csstype/static-1.50",
      "batch-promise": "/batch-promise/static-1.947",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4006",
      "merchandise-lib": "/merchandise-lib/static-1.233",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.8898",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "redux-undo": "/redux-undo/static-1.10",
      "hubspotter-http": "/hubspotter-http/static-1.3998",
      "navigation-messaging": "/navigation-messaging/static-1.5511",
      "feature-store-service-types": "/feature-store-service-types/static-1.3999",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3990",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.15833",
      "seo-tools-lib": "/seo-tools-lib/static-1.5775",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "markdown-it": "/markdown-it/static-1.6",
      "zustand": "/zustand/static-1.51",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3474",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6146",
      "persist-promise": "/persist-promise/static-1.3105",
      "hub-http-janus": "/hub-http-janus/static-1.699",
      "reactive-lib": "/reactive-lib/static-1.93",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8456",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.395",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11855",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.20637",
      "social-insights-client-types": "/social-insights-client-types/static-1.20289",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15212",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.17805",
      "marketplace-ui-details": "/marketplace-ui-details/static-1.7702",
      "property-management-iframe": "/property-management-iframe/static-1.10904",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.5959",
      "hls.js": "/hls.js/static-1.24",
      "js-cookie": "/js-cookie/static-1.18",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4054",
      "highcharts": "/highcharts/static-8.89",
      "report-customization-components": "/report-customization-components/static-1.11525",
      "reporting-action-components": "/reporting-action-components/static-1.39589",
      "reporting-data": "/reporting-data/static-1.64947",
      "reporting-enablement": "/reporting-enablement/static-1.20785",
      "reporting-snowflake": "/reporting-snowflake/static-1.53567",
      "reporting-visualizations": "/reporting-visualizations/static-1.57024",
      "reporting-plugins": "/reporting-plugins/static-1.9288",
      "reporting-reports": "/reporting-reports/static-1.64627",
      "highlight.js": "/highlight.js/static-1.45",
      "ui-addon-teams": "/ui-addon-teams/static-1.20700",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10419",
      "calling-error-reporting": "/calling-error-reporting/static-1.30640",
      "worker-connection-library": "/worker-connection-library/static-1.15864",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5844",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.33537",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6712",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7302",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4694",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8541",
      "fsm": "/fsm/static-1.3045",
      "policy-lib": "/policy-lib/static-1.6111",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.8604",
      "final-form": "/final-form/static-1.53",
      "academy-common-lib": "/academy-common-lib/static-1.11858",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2395",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.8840",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17402",
      "crm_universal": "/crm_universal/static-1.21156",
      "customer-data-content": "/customer-data-content/static-1.26083",
      "crm_schema": "/crm_schema/static-3.90008",
      "customer-data-email": "/customer-data-email/static-1.16930",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.19870",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.361",
      "customer-data-associations": "/customer-data-associations/static-1.6577",
      "customer-data-rte": "/customer-data-rte/static-1.31528",
      "cv-backend-services": "/cv-backend-services/static-1.1336",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4859",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16492",
      "prosemirror": "/prosemirror/static-1.13",
      "qrcode-generator": "/qrcode-generator/static-1.52",
      "quotes-client-types": "/quotes-client-types/static-1.35862",
      "trials-service-types": "/trials-service-types/static-1.3407",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7108",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16339",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6489",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6724",
      "immutable-less": "/immutable-less/static-1.3908",
      "react-window": "/react-window/static-1.13",
      "ai-studio-lib": "/ai-studio-lib/static-1.9752",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9699",
      "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.17762",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.11977",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7400",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7010",
      "property-management-common": "/property-management-common/static-1.3191",
      "storybook-react": "/storybook-react/static-1.16",
      "trellis-story-utils": "/trellis-story-utils/static-1.3896",
      "dashboard-lib": "/dashboard-lib/static-1.79135",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8053",
      "reporting-client-types": "/reporting-client-types/static-1.2251",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.11289",
      "html-to-image": "/html-to-image/static-1.38",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.11720",
      "crm-object-map": "/crm-object-map/static-1.4292",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7065",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.33762",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3091",
      "academy-service-client": "/academy-service-client/static-1.2993",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3135",
      "sales-views-client-types": "/sales-views-client-types/static-1.3607",
      "utility-belt": "/utility-belt/static-1.1847",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8156",
      "sequences-lib": "/sequences-lib/static-1.7101",
      "draft-content-plugins": "/draft-content-plugins/static-1.26877",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-plugins": "/draft-plugins/static-2.20523",
      "knowledge-content-types": "/knowledge-content-types/static-1.8036",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3395",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "apps-service-types": "/apps-service-types/static-1.3341",
      "oauth-service-types": "/oauth-service-types/static-1.3593",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.13846",
      "crm-component-utils": "/crm-component-utils/static-1.37412",
      "redux-actions": "/redux-actions/static-3.7",
      "crm-fe-perf": "/crm-fe-perf/static-1.22315",
      "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.3935",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.8245",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3584",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.6958",
      "card-properties-lib": "/card-properties-lib/static-1.42378",
      "crm-actions": "/crm-actions/static-1.5550",
      "crm-cards-data": "/crm-cards-data/static-1.340",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.41678",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.7785",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44304",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.13547",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35438",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.37746",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.9922",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.52755",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.19967",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.15916",
      "project-storage": "/project-storage/static-1.4041",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.69777",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4638",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.78493",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.5995",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.52771",
      "commerce-products-api": "/commerce-products-api/static-1.1287",
      "SafeStorage": "/SafeStorage/static-1.3730",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.54829",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.100450",
      "totals-ui-components": "/totals-ui-components/static-1.21915",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3262"
    },
    "project": "page-editor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};